/* Weingut-Logos auf dunklem Grund lesbar machen (sections/herkunft-karte.liquid, sections/produkt-herkunft.liquid).
   Jedes <img data-wg-logo crossorigin="anonymous"> wird klein in ein Canvas gezeichnet und eingeordnet:
   – deckender eigener Hintergrund (Ecken nicht durchsichtig) → Plakette in genau dieser Farbe,
   – durchsichtig mit überwiegend dunkler Schrift → helle Plakette,
   – durchsichtig und hell (weiß, gold) → bleibt ohne Plakette auf dem dunklen Grund.
   Klappt das Auslesen nicht (z. B. ohne CORS), bleibt das Logo unverändert. */
(function () {
  var HELL = '#f6f2ea';

  function platte(img, farbe) {
    img.style.backgroundColor = farbe;
    img.style.padding = '6px 10px';
    img.style.borderRadius = '8px';
    img.style.boxSizing = 'content-box';
  }

  function pruefe(img) {
    if (img.__wgl) return;
    var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    if (!nw || !nh) return;
    img.__wgl = true;
    var s = 64 / Math.max(nw, nh);
    var w = Math.max(4, Math.round(nw * s)), h = Math.max(4, Math.round(nh * s));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var px;
    try {
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      px = ctx.getImageData(0, 0, w, h).data;
    } catch (e) { return; }

    var ecke = function (x, y) { var i = (y * w + x) * 4; return [px[i], px[i + 1], px[i + 2], px[i + 3]]; };
    var ecken = [ecke(0, 0), ecke(w - 1, 0), ecke(0, h - 1), ecke(w - 1, h - 1)];
    if (ecken.every(function (e) { return e[3] > 200; })) {
      var e = ecken[0];
      platte(img, 'rgb(' + e[0] + ',' + e[1] + ',' + e[2] + ')');
      return;
    }

    var deckend = 0, dunkel = 0;
    for (var i = 0; i < px.length; i += 4) {
      if (px[i + 3] < 128) continue;
      deckend++;
      if (0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2] < 100) dunkel++;
    }
    if (deckend && dunkel / deckend > 0.2) platte(img, HELL);
  }

  function init() {
    document.querySelectorAll('img[data-wg-logo]').forEach(function (img) {
      if (img.complete && img.naturalWidth) pruefe(img);
      else img.addEventListener('load', function () { pruefe(img); }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
